import React, { forwardRef, useState } from 'react'

import clsx from 'clsx'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { makeStyles, withStyles } from '@material-ui/styles'
import MaterialTable from 'material-table'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import LastPageIcon from '@material-ui/icons/LastPage'
import AddIcon from '@material-ui/icons/Add'
import DeleteIcon from '@material-ui/icons/Delete'

import moment from 'moment'
import localization from 'moment/locale/pt-br'
import red from '@material-ui/core/colors/red'
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  Button,
  CircularProgress,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Modal,
  Backdrop,
  Fade,
  DialogTitle,
} from '@material-ui/core'
import { useGerenciamentoBalisticaService } from 'hooks/useGerenciamentoBalisticaService'
import { ModalItemBalistico } from '../ModalItemBalistico'

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0,
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  inner: {
    minWidth: 700,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: '80%',
  },
  confirmarButton: {
    backgroundColor: '#303303',
    color: 'white',
    '&:hover': {
      backgroundColor: '#303303',
      color: 'black',
  },
  }
}))

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(red[500]),
    backgroundColor: red[400],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
}))(Button)

export const Results = (props) => {
  const { className, dados, modeloBalistico, fetchDados, carregando, ...rest } = props

  const classes = useStyles()

  moment.locale('pt-br', localization)
  const gerenciamentoBalisticoService = useGerenciamentoBalisticaService()
  const [openModal, setOpenModal] = useState(false)
  const [fecharModal, setFecharModal] = useState(false)
  const [isDeletarOpen, setIsDeletarOpen] = useState(false)
  const [idItemDeletar, setIdItemDeletar] = useState(-1)

  const handleOpenModal = () => {
    setOpenModal(true)
  }

  const cliqueFecharModal = () => {
    setFecharModal(true)
  }

  const fecharModalFechar = () => {
    setFecharModal(false)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
    setFecharModal(false)
  }

  const clickOpenModalDeletar = (dadoGerenciavel) => {
    setIsDeletarOpen(true)
    setIdItemDeletar(dadoGerenciavel.id)
  }

  const handleCloseModalDeletar = () => {
    setIsDeletarOpen(false)
  }

  const handleDeletarDadoGerenciavel = async () => {
    handleCloseModalDeletar()
    await gerenciamentoBalisticoService.deletarItemGerenciamentoBalistico(
      idItemDeletar,
      modeloBalistico.modelo
    )
    gerenciamentoBalisticoService.listarDadosItensBalisticosGlobal(modeloBalistico.modelo)
  }

  const handleAdicionarItemBalistico = async (nome) => {
    handleCloseModal()
    await gerenciamentoBalisticoService.adicionarItemGerenciamentoBalistico(
      nome,
      modeloBalistico.modelo
    )
    gerenciamentoBalisticoService.listarDadosItensBalisticosGlobal(modeloBalistico.modelo)
  }

  return (
    <div>
      <div {...rest} className={clsx(classes.root, className)}>
        <Card {...rest} className={clsx(classes.root, className)}>
          {carregando || !modeloBalistico ? (
            <div className={classes.carregando}>
              <CircularProgress disableShrink />
            </div>
          ) : (
            <CardContent>
              <div>
                <Grid alignItems="flex-end" container justify="space-between" spacing={3}>
                  <Grid item>
                    <CardHeader title={modeloBalistico ? modeloBalistico.nome : ''} />
                  </Grid>
                  <Grid item>
                    <Button onClick={handleOpenModal} variant="contained" color="secondary">
                      <AddIcon className={classes.addIcon} />
                      Cadastrar novo
                    </Button>
                    <Modal
                      aria-labelledby="transition-modal-title"
                      aria-describedby="transition-modal-description"
                      className={classes.modal}
                      open={openModal}
                      onClose={cliqueFecharModal}
                      closeAfterTransition
                      BackdropComponent={Backdrop}
                      BackdropProps={{
                        timeout: 500,
                      }}
                    >
                      <Fade in={openModal}>
                        <div className={classes.paper}>
                          <ModalItemBalistico
                            // examesFormState={formState.values.exames}
                            modelo={modeloBalistico.modelo}
                            handleAdicionarItemBalistico={handleAdicionarItemBalistico}
                          />
                        </div>
                      </Fade>
                    </Modal>
                  </Grid>
                </Grid>
                <Divider className={classes.divider} />
                <Dialog
                  open={fecharModal}
                  onClose={fecharModalFechar}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Deseja realmente fechar? O nome do item digitado será perdido.
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={fecharModalFechar} color="primary">
                      Voltar
                    </Button>
                    <ColorButton
                      onClick={handleCloseModal}
                      variant="outlined"
                      color="secondary"
                      autoFocus
                    >
                      Confirmar
                    </ColorButton>
                  </DialogActions>
                </Dialog>

                <Dialog
                  open={isDeletarOpen}
                  onClose={handleCloseModalDeletar}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">Tem certeza que deseja deletar?</DialogTitle>
                  <DialogActions>
                    <Button onClick={handleCloseModalDeletar} color="red">
                      Cancelar
                    </Button>
                    <Button
                      onClick={handleDeletarDadoGerenciavel}
                      className={clsx(classes.confirmarButton)}
                      autoFocus
                    >
                      Confirmar
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
              <PerfectScrollbar>
                <div className={classes.inner}>
                  <MaterialTable
                    localization={{
                      pagination: {
                        labelDisplayedRows: '{from}-{to} de {count}',
                        labelRowsSelect: 'linhas',
                        nextTooltip: 'Página seguinte',
                        previousTooltip: 'Página anterior',
                        lastTooltip: 'Última página',
                        firstTooltip: 'Primeira página',
                      },
                      toolbar: {
                        nRowsSelected: '{0} linha(s) selecionadas',
                        searchPlaceholder: 'Buscar',
                      },
                      header: {
                        actions: 'Ações',
                      },
                      body: {
                        emptyDataSourceMessage: 'Nada para mostrar',
                        filterRow: {
                          filterTooltip: 'Filtro',
                        },
                      },
                    }}
                    title=""
                    columns={[
                      {
                        title: 'Nome',
                        field: 'nome',
                      },
                    ]}
                    data={dados}
                    options={{
                      actionsColumnIndex: -1,
                      search: true,
                      pageSize: 10,
                      searchFieldStyle: {
                        flexGrow: 1,
                        height: 42,
                        // padding: theme.spacing(0, 2),
                        display: 'flex',
                        alignItems: 'center',
                      },
                      headerStyle: {
                        backgroundColor: '#f4f6f8',
                      },
                    }}
                    actions={[
                      {
                        icon: DeleteIcon,
                        tooltip: 'Deletar Item',
                        onClick: (event, rowData) => clickOpenModalDeletar(rowData),
                      },
                    ]}
                    icons={{
                      DetailPanel: forwardRef((propsDetailPanel, ref) => (
                        <ArrowForwardIosIcon {...propsDetailPanel} ref={ref} />
                      )),
                      SortArrow: forwardRef((propsSortArrow, ref) => (
                        <ArrowDownwardIcon {...propsSortArrow} ref={ref} />
                      )),
                      Search: forwardRef((propsSearch, ref) => (
                        <SearchIcon {...propsSearch} ref={ref} />
                      )),
                      ResetSearch: forwardRef((propsResetSearch, ref) => (
                        <ClearIcon {...propsResetSearch} ref={ref} />
                      )),
                      NextPage: forwardRef((propsNextPage, ref) => (
                        <NavigateNextIcon {...propsNextPage} ref={ref} />
                      )),
                      PreviousPage: forwardRef((propsPreviousPage, ref) => (
                        <NavigateBeforeIcon {...propsPreviousPage} ref={ref} />
                      )),
                      FirstPage: forwardRef((propsFirstPage, ref) => (
                        <FirstPageIcon {...propsFirstPage} ref={ref} />
                      )),
                      LastPage: forwardRef((propsLastPage, ref) => (
                        <LastPageIcon {...propsLastPage} ref={ref} />
                      )),
                    }}
                    style={{
                      padding: '16px',
                      fontSize: '14px',
                      textAlign: 'left',
                      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                      fontWeight: '400',
                      lineHeight: '21px',
                      borderBottom: '1px solid #eeeeee',
                      letterSpacing: '-0.05px',
                      verticalAlign: 'inherit',
                    }}
                  />
                </div>
              </PerfectScrollbar>
            </CardContent>
          )}
        </Card>
      </div>
    </div>
  )
}
